<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت کاربران</h1>

      <a href="#" @click.prevent="modalCreate = true"
         class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <PlusIcon class="ml-2"/>
        افزودن کاربر
      </a>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>نام کاربر</th>
        <th>شماره همراه</th>
        <th>نقش</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, index) in users"
          :key="user.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ user.name || '-' }}</td>
        <td>{{ user.phone }}</td>
        <td>{{ user.role.name }}</td>
        <td>
          <a href="#" @click.prevent="editUser = user; modalEdit = true">
            <PenIcon class="text-orange"/>
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalUser
        :show="modalCreate"
        @click="modalCreate = !modalCreate"
        @created="userCreated"/>

    <ModalUser
        :show="modalEdit"
        @click="modalEdit = !modalEdit"
        :user="editUser"
        @edited="userEdited"/>


    <VLoadingScreen :show="loading"/>

  </VPanel>
</template>

<script>
import {getUsers} from "@/API/API";
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import PenIcon from "@/components/Icons/PenIcon";
import ModalUser from "@/components/Modal/ModalUser";

export default {
  name: "UserView",
  components: {ModalUser, PenIcon, VLoadingScreen, PlusIcon, VPanel},
  data() {
    return {
      users: [],
      loading: true,
      modalCreate: false,
      modalEdit: false,
      editUser: {}
    }
  },
  async created() {
    this.users = (await getUsers()).data
    this.loading = false
  },
  methods: {
    async userCreated() {
      this.modalCreate = false
      this.loading = true
      this.users = (await getUsers()).data
      this.loading = false
    },
    async userEdited() {
      this.modalEdit = false
      this.loading = true
      this.users = (await getUsers()).data
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>